<template>
  <v-form class="w-full">
    <v-switch
      :disabled="!showAisToggle"
      class="py-2"
      v-if="showAisToggle"
      hide-details
      @change="$store.myActions.UI_TOGGLE_AIS_VISIBILITY(uiid)"
      :input-value="mapState.showAis"
      :label="$t('Pilot.Glider.ShowAis')"
    ></v-switch>
    <v-layout v-if="mapState.showAis">
      <v-flex xs-11 class="pl-1">
        <v-slider
          hide-details
          class="my-0"
          @input="$store.myActions.UI_SET_LAYERMAP_OPACITY({ layerId: 'AIS', opacity: $event, uiid })"
          :value="mapState.layermapOpacity['AIS'] == 0 ? 0 : mapState.layermapOpacity['AIS'] || 100"
          :min="0"
          :max="100"
          step="1"
        />
      </v-flex>
      <v-flex xs-1 class="flex justify-center items-center settings ml-3" :class="{ selected: showAisConfig }">
        <v-icon @click.prevent="showAisConfig = !showAisConfig">mdi-cog</v-icon>
      </v-flex>
    </v-layout>
    <div class="config pa-2" v-if="mapState.showAis && showAisConfig">
      <div></div>
      <v-select
        hide-details
        :items="datesFrom"
        item-text="libelle"
        item-value="value"
        label="From :"
        v-model="from"
      ></v-select>
      <v-select
        hide-details
        :items="datesTo"
        item-text="libelle"
        item-value="value"
        label="To :"
        v-model="to"
      ></v-select>
    </div>
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_CYCLE_VISIBILITY(uiid)"
      :input-value="mapState.showCycle"
      :label="$t('Pilot.Glider.ShowCycle')"
    ></v-switch>
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_HEADING_VISIBILITY(uiid)"
      :input-value="mapState.showHeading"
      :label="$t('Pilot.Glider.ShowHeading')"
    ></v-switch>
    <v-switch
      class="py-2"
      v-if="mapState.typeUiid == 'detail'"
      hide-details
      @change="$store.myActions.UI_TOGGLE_DRIFT_VISIBILITY(uiid)"
      :input-value="mapState.showDrift"
      :label="$t('Pilot.Glider.ShowDrift')"
    ></v-switch>
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_OCEANCURRENT(uiid)"
      :input-value="mapState.showOceanCurrent"
      :label="$t('Pilot.Glider.ShowCurrents')"
    ></v-switch>
    <div class="caption" v-show="mapState.showOceanCurrent">
      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-text-field
            v-model.number="currentMin"
            type="number"
            step="0.01"
            :label="$t('Pilot.Layer.Config.MinSpeed')"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            v-model.number="currentMax"
            type="number"
            step="0.01"
            :label="$t('Pilot.Layer.Config.MaxSpeed')"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            v-model.number="currentZoom"
            type="number"
            step="0.1"
            :label="$t('Pilot.Layer.Config.CurrentZoom')"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_WAYPOINT_VISIBILITY(uiid)"
      :input-value="mapState.showWaypoint"
      :label="$t('Pilot.Glider.ShowTargetWaypoint')"
    ></v-switch>
    <!--<v-switch class="py-2" hide-details @change="$store.myActions.UI_TOGGLE_PATH_VISIBILITY(uiid)" :input-value="mapState.showPath" :label="$t('Pilot.Glider.ShowPath')"></v-switch>-->
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_MISSIONPLAN_VISIBILITY(uiid)"
      :input-value="mapState.showMissionPlan"
      :label="$t('Pilot.Glider.ShowMissionPlan')"
    ></v-switch>
    <v-switch
      class="py-2"
      hide-details
      v-if="mapState.showMissionPlan"
      @change="$store.myActions.UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY(uiid)"
      :input-value="mapState.showMissionPlanValidation"
      :label="$t('Pilot.Glider.ShowMissionPlanValidation')"
    ></v-switch>
    <v-switch
      class="py-2"
      hide-details
      @change="$store.myActions.UI_TOGGLE_MISSIONLAYER_VISIBILITY(uiid)"
      :input-value="mapState.showMissionLayer"
      :label="$t('Pilot.Glider.ShowMissionLayer')"
    ></v-switch>
    <v-layout>
      <v-flex xs-11 class="pl-1">
        <v-slider
          v-if="mapState.showMissionLayer"
          hide-details
          class="my-0"
          @input="$store.myActions.UI_SET_MISSIONLAYERMAP_OPACITY({ opacity: $event, uiid })"
          :value="mapState.missionLayermapOpacity == 0 ? 0 : mapState.missionLayermapOpacity || 100"
          :min="0"
          :max="100"
          step="1"
        />
      </v-flex>
      <v-flex xs-1></v-flex>
    </v-layout>
    <!-- <v-switch v-if="showEndMissionToggle" class="py-2" hide-details @change="$store.myActions.UI_TOGGLE_ENDMISSION_SIMULATION_VISIBILITY(uiid)" :input-value="mapState.showEndMissionSimulation" :label="$t('Pilot.Glider.showEndMissionSimulation')"></v-switch>                    -->
    <!-- <v-slider v-if="mapState.showEndMissionSimulation" hide-details class="my-0" @input="$store.myActions.UI_SET_ENDMISSION_SIMULATION_OPACITY({opacity:$event,uiid})" :value="mapState.endMissionSimulationMapOpacity == 0?0:(mapState.endMissionSimulationMapOpacity||100)" :min="0" :max="100" step=1 />             -->

    {{ $t('Pilot.Glider.DefaultGliderColor') }}
    <v-menu offset-y>
      <v-btn slot="activator" flat>
        {{ $t(`Color.${mapState.defaultMapStyles.name}`) }}
        <v-icon>mdi-palette</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="style in stylesList"
          :key="style.name"
          @click="$store.myActions.UI_SET_DEFAULT_MAP_STYLE({ uiid, style })"
        >
          <v-list-tile-avatar :class="style.name" size="25" small :color="style.color"></v-list-tile-avatar>
          <v-list-tile-title>{{ $t(`Color.${style.name}`) }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { stylesList } from '@/components/map/MapStyles'
import moment from 'moment'
export default {
  name: 'MapPanelGlider',
  props: {
    uiid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      test: false,
      stylesList,
      showAisConfig: false,
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(['uistatebyuiid']),
    //recupere le state de travail
    mapState() {
      return this.uistatebyuiid(this.uiid)
    },
    from: {
      get() {
        return this.mapState.aisStartDateUtc
      },
      set(newVal) {
        this.mapState.aisStartDateUtc = newVal
      },
    },
    to: {
      get() {
        return this.mapState.aisEndDateUtc
      },
      set(newVal) {
        this.mapState.aisEndDateUtc = newVal
      },
    },
    currentMin: {
      get() {
        return this.mapState?.currentMin
      },
      set(newVal) {
        this.$store.myActions.UI_SET_BORNE_MIN_CURRENT({ min: newVal, uiid: this.uiid })
      },
    },
    currentMax: {
      get() {
        return this.mapState?.currentMax
      },
      set(newVal) {
        this.$store.myActions.UI_SET_BORNE_MAX_CURRENT({ max: newVal, uiid: this.uiid })
      },
    },
    currentZoom: {
      get() {
        return this.mapState?.currentZoom
      },
      set(newVal) {
        this.$store.myActions.UI_SET_ZOOM_CURRENT({ zoom: newVal, uiid: this.uiid })
      },
    },
    showAisToggle() {
      return this.$store.myGetters.userProfile.config.ais_on
    },
    showEndMissionToggle() {
      return (this.uiid ?? '').startsWith('MissionDetailMap')
    },
    datesFrom() {
      const endDate = new Date()
      endDate.setMinutes(0, 0, 0)
      endDate.setHours(endDate.getHours())

      //array des dates commencant à endDate et reculant par pas de 1 heures sur 47 heures
      const dates = []
      for (let i = 0; i < 71; i++) {
        const date = new Date(endDate)
        date.setHours(endDate.getHours() - i)
        dates.push({
          libelle: this.parseDateToUtc(date),
          value:
            (i == 0 && new Date().getMinutes() >= 30) || (i == 1 && new Date().getMinutes() < 30)
              ? null
              : date.toISOString(),
        })
      }
      return dates
    },
    datesTo() {
      const endDate = new Date()
      endDate.setMinutes(0, 0, 0)
      endDate.setHours(endDate.getHours() + 1)

      //array des dates commencant à endDate et reculant par pas de 1 heures sur 48 heures
      const dates = []
      for (let i = 0; i < 71; i++) {
        const date = new Date(endDate)
        date.setHours(endDate.getHours() - i)
        dates.push({
          libelle: this.parseDateToUtc(date),
          value: i == 0 ? null : date.toISOString(),
        })
      }

      return dates
    },
  },
  methods: {
    parseDateToUtc(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm UTC') //this.$options.filters['formatDate'](data,"YYYY-MM-DD HH:mm")
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.v-input__icon--append {
  justify-content: flex-end;
}

.settings .v-icon {
  font-size: 16px;
}
.settings.selected {
  background: #eee;
  border-radius: 5px 5px 0px 0px;
}
.settings {
  max-width: 30px;
}

.config {
  background: #eee;

  border-radius: 5px 0px 5px 5px;
}
</style>
